<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  consumed: {
    type: Number,
    required: true,
  },
  totalCount: {
    type: Number,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
});

const percent = computed(() => {
  if (!props.totalCount) return 0;

  return Math.min(100, Math.round((props.consumed / props.totalCount) * 100));
});

const colorClass = computed(() => {
  if (percent.value < 50) {
    return 'bg-n-teal-10';
  }
  if (percent.value < 80) {
    return 'bg-n-amber-10';
  }
  return 'bg-n-ruby-10';
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-center justify-between gap-4">
      <span class="text-xs font-semibold uppercase tracking-wider text-n-slate-11">
        {{ title }}
      </span>
      <span class="text-sm font-semibold tabular-nums text-n-slate-12">
        {{ consumed }} / {{ totalCount }}
      </span>
    </div>
    <p v-if="subtitle" class="text-xs text-n-slate-11">
      {{ subtitle }}
    </p>
    <div
      class="h-2 w-full overflow-hidden rounded-full bg-n-slate-4"
      role="progressbar"
      :aria-valuenow="consumed"
      :aria-valuemin="0"
      :aria-valuemax="totalCount"
    >
      <div
        class="h-full rounded-full transition-all duration-300"
        :class="colorClass"
        :style="{ width: `${percent}%` }"
      />
    </div>
  </div>
</template>
